/**
 * Website-owned recruiter-facing technology and discipline labels.
 *
 * These labels are presentation metadata only. They do not control project
 * publication, ordering, stable-release identity, or source-repository truth.
 * Projects without an entry remain publishable and render without this line.
 */
export const projectCardSignals: Readonly<Record<string, readonly string[]>> = {
  bazzite_system_config: [
    "Python",
    "Bash",
    "Linux",
    "Configuration Management",
    "Automation",
  ],
  "pokemon-solver": ["Rust", "TypeScript", "React", "Tauri", "Simulation"],
  "project-design-standards": [
    "Agentic Engineering",
    "Documentation Systems",
    "Rust",
    "TypeScript",
    "Python",
  ],
  pulseflowjs: [
    "TypeScript",
    "Statistics",
    "Spatial Interpolation",
    "Meteorology",
    "Image Processing",
  ],
};
